(function(){
  var root = document.querySelector('[data-lamel-offers]');
  if(!root) return;

  var portal = document.createElement('div');
  portal.className = 'lamel-portal';
  document.body.appendChild(portal);

  var active = null;

  function closePortal(){
    if(!active) return;
    active.dd.classList.remove('is-open');
    active.btn.setAttribute('aria-expanded','false');
    if(active.originalParent){
      if(active.originalNextSibling && active.originalNextSibling.parentNode === active.originalParent){
        active.originalParent.insertBefore(active.panel, active.originalNextSibling);
      } else {
        active.originalParent.appendChild(active.panel);
      }
    }
    active.panel.classList.remove('is-portal');
    active.panel.style.left = '';
    active.panel.style.top = '';
    active.panel.style.width = '';
    active = null;
    portal.innerHTML = '';
  }

  function openPortal(dd){
    var btn = dd.querySelector('[data-dd-btn]');
    var panel = dd.querySelector('[data-dd-panel]');
    if(!btn || !panel) return;
    closePortal();
    dd.classList.add('is-open');
    btn.setAttribute('aria-expanded','true');
    var rect = btn.getBoundingClientRect();
var wrap = dd.closest('.lamel-offers-wrap');
var wrapRect = wrap ? wrap.getBoundingClientRect() : rect;
var isMobile = window.matchMedia('(max-width: 640px)').matches;

active = {
  dd: dd,
  btn: btn,
  panel: panel,
  originalParent: panel.parentNode,
  originalNextSibling: panel.nextSibling
};

portal.innerHTML = '';
portal.appendChild(panel);
panel.classList.add('is-portal');

var top = rect.bottom + 6;
var left = isMobile ? wrapRect.left : rect.left;
var width = isMobile ? wrapRect.width : rect.width;

var maxLeft = Math.max(8, window.innerWidth - width - 8);
left = Math.min(Math.max(8, left), maxLeft);

panel.style.position = 'fixed';
panel.style.left = left + 'px';
panel.style.top = top + 'px';
panel.style.width = width + 'px';
  }

  root.querySelectorAll('[data-dd]').forEach(function(dd){
    var btn = dd.querySelector('[data-dd-btn]');
    var panel = dd.querySelector('[data-dd-panel]');
    var textEl = dd.querySelector('[data-dd-text]');
var chipEl = dd.querySelector('[data-dd-chip]');
var card = dd.closest('.lamel-offer');
if(!btn || !panel || !card) return;

    btn.addEventListener('click', function(){
      var isOpen = dd.classList.contains('is-open');
      if(isOpen) closePortal();
      else openPortal(dd);
    });

    dd.querySelectorAll('[data-dd-opt]').forEach(function(opt){
      opt.addEventListener('click', function(){
        var vid = opt.getAttribute('data-vid');
var title = opt.getAttribute('data-title') || '';
var price = opt.getAttribute('data-price') || '';
var compare = opt.getAttribute('data-compare') || '';
var available = opt.getAttribute('data-available') === '1';
var image = opt.getAttribute('data-image') || '';
var imageAlt = opt.getAttribute('data-image-alt') || title;
var swatch = opt.getAttribute('data-swatch') || '';

if(textEl) textEl.textContent = title;

if(chipEl && swatch){
  chipEl.style.backgroundImage = 'url("' + swatch.replace(/"/g, '\\"') + '")';
}
        var hid = card.querySelector('[data-variant-id]');
        if(hid) hid.value = vid;
        var priceNow = card.querySelector('[data-price-now]');
        var priceWas = card.querySelector('[data-price-was]');
        if(priceNow) priceNow.textContent = price;
        if(priceWas){
  priceWas.textContent = compare;
  priceWas.style.display = compare ? '' : 'none';
}

var img = card.querySelector('.lamel-offer__img');
if(img && image){
  img.removeAttribute('srcset');
  img.removeAttribute('sizes');
  img.src = image;
  img.alt = imageAlt;
}

var atcBtn = card.querySelector('[data-atc-btn]');
        if(atcBtn){
          atcBtn.disabled = !available;
          atcBtn.textContent = available ? 'Add' : 'Sold out';
        }
        closePortal();
        btn.focus({ preventScroll:true });
      });
    });
  });

  window.addEventListener('scroll', function(){ if(active) closePortal(); },{ passive:true });
  window.addEventListener('resize', function(){ if(active) closePortal(); });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closePortal(); });
  document.addEventListener('click', function(e){
    if(!active) return;
    if(active.dd.contains(e.target) || active.panel.contains(e.target)) return;
    closePortal();
  });

async function refreshCartUI(){
  try{
    var res = await fetch('/cart.js',{
      headers:{ 'Accept':'application/json' },
      credentials:'same-origin'
    });

    if(!res.ok) return;

    var cart = await res.json();

    document.dispatchEvent(new CustomEvent('cart:updated',{
      bubbles:true,
      detail:{ cart:cart }
    }));

    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{
      bubbles:true,
      detail:{ cart:cart }
    }));

    document.dispatchEvent(new CustomEvent('cart:refresh',{
      bubbles:true,
      detail:{ cart:cart }
    }));

    if(window.MinimogEvents && typeof window.MinimogEvents.publish === 'function'){
      window.MinimogEvents.publish('cart:updated', cart);
      window.MinimogEvents.publish('cart:refresh', cart);
    }
  }catch(e){}
}

  root.querySelectorAll('[data-atc-form]').forEach(function(form){
    form.addEventListener('submit', async function(e){
      e.preventDefault();
      var btn = form.querySelector('[data-atc-btn]');
      var input = form.querySelector('[data-variant-id]');
      if(!btn || !input) return;
      var variantId = parseInt(input.value, 10);
      if(!variantId || Number.isNaN(variantId)) return;
      if(btn.disabled) return;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      try{
        var body = new URLSearchParams();
        body.append('id', String(variantId));
        body.append('quantity','1');
        body.append('properties[_source]', 'complete-the-look');
        body.append('properties[_source_product]', '{{ product.handle }}');
        var res = await fetch('/cart/add.js',{
          method:'POST',
          headers:{
            'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8',
            'Accept':'application/json'
          },
          credentials:'same-origin',
          body:body.toString()
        });
        if(!res.ok) throw new Error('Add failed');
        btn.textContent = 'Added';
        await refreshCartUI();
        setTimeout(function(){
          btn.textContent = 'Add';
          btn.disabled = false;
        }, 900);
      }catch(err){
        btn.textContent = 'Error';
        setTimeout(function(){
          btn.textContent = 'Add';
          btn.disabled = false;
        }, 1100);
      }
    });
  });
})();